import catalog from './classes.json';

const source = catalog.classes || catalog;
export const CLASS_LIST_VERSION = catalog.version || 'yolo63-v1';
export const CLASS_LIST = (Array.isArray(source)
  ? source.map((item, index) => typeof item === 'string' ? { id: index, name: item } : item)
  : Object.entries(source).map(([id, name]) => ({ id: Number(id), name })))
  .map((item) => ({ ...item, id: Number(item.id), name: String(item.name || item.label || item.species) }));

const FRIENDLY_NAMES = { 22: 'Hippo' };
export const displayClass = (item) => FRIENDLY_NAMES[item.id] || item.label || item.name.replace(/_/g, ' ').replace(/^./, (letter) => letter.toUpperCase());
export const className = (id) => {
  const item = CLASS_LIST.find((candidate) => candidate.id === Number(id));
  return item ? displayClass(item) : 'Unknown animal';
};
export const PREDATOR_IDS = [1, 0, 2, 3, 4, 32];
export const COMMON_IDS = [15, 5, 6, 11, 14, 35, 20, 22, 31];
export const classesForIds = (ids) => ids.map((id) => CLASS_LIST.find((item) => item.id === id)).filter(Boolean);
